


import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { useState, useEffect } from "react";
import { FaAngleUp } from "react-icons/fa";
import ScrollToTop from "./components/ScrollToTop";
import AboutUs from "./page/ahbaab/AboutUs";
import ContactUs from "./page/ahbaab/ContactUs";
import Products from "./page/ahbaab/Products";
import ProductsByCategory from "./page/ahbaab/ProductsByCategory";
import ErrorPage from "./page/ahbaab/ErrorPage";
import ProductDetailOfEach from "./page/ahbaab/ProductDetailOfEach";
import MainHome from "./page/ahbaab/MainHome";
import FAQPage from "./page/ahbaab/FAQ";
import Blogs from "./page/ahbaab/Blogs";
import TermsConditions from "./page/ahbaab/TermsConditions";
import PrivacyPolicy from "./page/ahbaab/PrivacyPolicy";

function App() {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <BrowserRouter>
        <div className="top-to-btm">
          {showTopBtn && (
            <FaAngleUp
              className="icon-position icon-style "
              style={{ zIndex: 199 }}
              onClick={goToTop}
            />
          )}
        </div>

        <ScrollToTop />

        <Routes>

          {/* QU - LUCENCY PRIVATE LIMITED */}

          <Route path='/' element={<MainHome />} />
          <Route path='/about-us' element={<AboutUs />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/products' element={<Products />} />
          <Route path='/products/:linkTag' element={<ProductsByCategory />} />
          <Route path='/products/:linkTag/:productCategoryLink' element={<ProductDetailOfEach />} />

          <Route path='/FAQ' element={<FAQPage />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/terms_conditions' element={<TermsConditions />} />
          <Route path='/privacy_policy' element={<PrivacyPolicy />} />


          <Route path='*' element={<ErrorPage />} />




        </Routes>
      </BrowserRouter>

    </>
  );
}

export default App;
